import { FETCH_ALL_COUNTRIES } from '../../constants/actionTypes'

export default (vlnCountries = [], action) => {
    switch (action.type) {
        case FETCH_ALL_COUNTRIES:
            return action.payload;
        default:
            return vlnCountries;
    }
}